import logo from '@/assets/brand/logo.png';
import { cn } from '@/design-system/lib/cn';

export type BrandLogoProps = {
  /**
   * Mantido para compatibilidade: a nova marca da Live Gospel usa a mesma arte
   * tanto no tema claro quanto no escuro (inclusive sobre a sidebar escura e o ícone do app).
   */
  tone?: 'auto' | 'light' | 'dark';
  /** Decorativo (`alt` vazio) quando o nome aparece ao lado. */
  decorative?: boolean;
  className?: string;
};

/** O símbolo LG da Live Gospel. O tamanho vem da classe (`size-10`…). */
export default function BrandLogo({ decorative = false, className }: BrandLogoProps) {
  return (
    <img
      src={logo}
      alt={decorative ? '' : 'Live Gospel'}
      width={512}
      height={398}
      className={cn('block shrink-0 object-contain', className)}
    />
  );
}
